import { useTranslations } from 'next-intl'

import { cn } from '@/shared/lib'

type Props = {
  onClick: () => void
}

export const DeleteButton = ({ onClick }: Props) => {
  const t = useTranslations('search_panel')

  return (
    <div
      role="button"
      tabIndex={0}
      className={cn(
        'typo-label1 absolute top-[34px] right-6 cursor-pointer rounded-sm font-medium text-black',
        'focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-none',
      )}
      onClick={onClick}
    >
      {t('recent_keyword.button_delete_all')}
    </div>
  )
}
